import createReactComponent from '../createReactComponent';
export default createReactComponent('outline', 'exposure-minus-1', 'IconExposureMinus1', [["path",{"d":"M3 12h6","key":"svg-0"}],["path",{"d":"M18 19v-14l-4 4","key":"svg-1"}]]);